import {createStore, combineReducers} from 'redux'
import {userReducer} from './userProfile/userReducer'
import {envReducer} from './envVariable/envReducer'
import {activeReducer} from './activeRegion/regionReducer'

const reducer = combineReducers({
    user: userReducer,
    env: envReducer,
    activeRegion: activeReducer
})
const store = createStore(reducer)
export default store; 